const SITES = [
    {
        id: 1,
        country: 'DE',
        currency: 'EUR',
        alternativeCurrency: 'EUR',
        domain: 'zooplus.de',
        language: 'de',
        locale: 'de-DE',
        alternateLocales: [],
        productGroupId: 2719,
        realm: 'zooplus',
    },
    {
        id: 2,
        country: 'GB',
        currency: 'EUR',
        alternativeCurrency: 'EUR',
        domain: 'zooplus.com',
        language: 'en',
        locale: 'en-GB',
        alternateLocales: [],
        productGroupId: 20758,
        realm: 'zooplus',
    },
    {
        id: 3,
        country: 'GB',
        currency: 'EUR',
        alternativeCurrency: 'GBP',
        domain: 'zooplus.co.uk',
        language: 'en',
        locale: 'en-GB',
        alternateLocales: [],
        productGroupId: 3315,
        realm: 'zooplus',
    },
    {
        id: 4,
        country: 'FR',
        currency: 'EUR',
        alternativeCurrency: 'EUR',
        domain: 'zooplus.fr',
        language: 'fr',
        locale: 'fr-FR',
        alternateLocales: [],
        productGroupId: 3884,
        realm: 'zooplus',
    },
    {
        id: 7,
        country: 'NL',
        currency: 'EUR',
        alternativeCurrency: 'EUR',
        domain: 'zooplus.nl',
        language: 'nl',
        locale: 'nl-NL',
        alternateLocales: [],
        productGroupId: 6114,
        realm: 'zooplus',
    },
    {
        id: 8,
        country: 'PL',
        currency: 'EUR',
        alternativeCurrency: 'PLN',
        domain: 'zooplus.pl',
        language: 'pl',
        locale: 'pl-PL',
        alternateLocales: [],
        productGroupId: 7245,
        realm: 'zooplus',
    },
    {
        id: 11,
        country: 'IE',
        currency: 'EUR',
        alternativeCurrency: 'EUR',
        domain: 'zooplus.ie',
        language: 'en',
        locale: 'en-IE',
        alternateLocales: [],
        productGroupId: 20758,
        realm: 'zooplus',
    },
    {
        id: 12,
        country: 'IT',
        currency: 'EUR',
        alternativeCurrency: 'EUR',
        domain: 'zooplus.it',
        language: 'it',
        locale: 'it-IT',
        alternateLocales: [],
        productGroupId: 8405,
        realm: 'zooplus',
    },
    {
        id: 14,
        country: 'BE',
        currency: 'EUR',
        alternativeCurrency: 'EUR',
        domain: 'zooplus.be',
        language: 'fr',
        locale: 'fr-BE',
        alternateLocales: [],
        productGroupId: 26690,
        realm: 'zooplus',
    },
    {
        id: 15,
        country: 'ES',
        currency: 'EUR',
        alternativeCurrency: 'EUR',
        domain: 'zooplus.es',
        language: 'es',
        locale: 'es-ES',
        alternateLocales: [],
        productGroupId: 11638,
        realm: 'zooplus',
    },
    {
        id: 16,
        country: 'CZ',
        currency: 'EUR',
        alternativeCurrency: 'CZK',
        domain: 'zoohit.cz',
        language: 'cs',
        locale: 'cs-CZ',
        alternateLocales: [],
        productGroupId: 18204,
        realm: 'zooplus',
    },
    {
        id: 18,
        country: 'FI',
        currency: 'EUR',
        alternativeCurrency: 'EUR',
        domain: 'zooplus.fi',
        language: 'fi',
        locale: 'fi-FI',
        alternateLocales: [],
        productGroupId: 24437,
        realm: 'zooplus',
    },
    {
        id: 19,
        country: 'SK',
        currency: 'EUR',
        alternativeCurrency: 'EUR',
        domain: 'zoohit.sk',
        language: 'sk',
        locale: 'sk-SK',
        alternateLocales: [],
        productGroupId: 32213,
        realm: 'zooplus',
    },
    {
        id: 20,
        country: 'RU',
        currency: 'EUR',
        alternativeCurrency: 'EUR',
        domain: 'zoochic-eu.ru',
        language: 'ru',
        locale: 'ru-RU',
        alternateLocales: [],
        productGroupId: 36514,
        realm: 'zooplus',
    },
    {
        id: 21,
        country: 'DK',
        currency: 'EUR',
        alternativeCurrency: 'DKK',
        domain: 'zooplus.dk',
        language: 'da',
        locale: 'da-DK',
        alternateLocales: [],
        productGroupId: 38215,
        realm: 'zooplus',
    },
    {
        id: 22,
        country: 'HU',
        currency: 'EUR',
        alternativeCurrency: 'HUF',
        domain: 'zooplus.hu',
        language: 'hu',
        locale: 'hu-HU',
        alternateLocales: [],
        productGroupId: 54095,
        realm: 'zooplus',
    },
    {
        id: 23,
        country: 'SI',
        currency: 'EUR',
        alternativeCurrency: 'EUR',
        domain: 'zoohit.si',
        language: 'sl',
        locale: 'sl-SI',
        alternateLocales: [],
        productGroupId: 54096,
        realm: 'zooplus',
    },
    {
        id: 24,
        country: 'RO',
        currency: 'EUR',
        alternativeCurrency: 'RON',
        domain: 'zooplus.ro',
        language: 'ro',
        locale: 'ro-RO',
        alternateLocales: [],
        productGroupId: 54097,
        realm: 'zooplus',
    },
    {
        id: 25,
        country: 'CH',
        currency: 'EUR',
        alternativeCurrency: 'CHF',
        domain: 'zooplus.ch',
        language: 'de',
        locale: 'de-CH',
        alternateLocales: [{ language: 'fr', locale: 'fr-CH' }],
        productGroupId: 59695,
        realm: 'zooplus',
    },
    {
        id: 26,
        country: 'SE',
        currency: 'EUR',
        alternativeCurrency: 'SEK',
        domain: 'zooplus.se',
        language: 'sv',
        locale: 'sv-SE',
        alternateLocales: [],
        productGroupId: 59745,
        realm: 'zooplus',
    },
    {
        id: 28,
        country: 'PT',
        currency: 'EUR',
        alternativeCurrency: 'EUR',
        domain: 'zooplus.pt',
        language: 'pt',
        locale: 'pt-PT',
        alternateLocales: [],
        productGroupId: 83213,
        realm: 'zooplus',
    },
    {
        id: 29,
        country: 'HR',
        currency: 'EUR',
        alternativeCurrency: 'EUR',
        domain: 'zooplus.hr',
        language: 'hr',
        locale: 'hr-HR',
        alternateLocales: [],
        productGroupId: 83215,
        realm: 'zooplus',
    },
    {
        id: 30,
        country: 'BG',
        currency: 'EUR',
        alternativeCurrency: 'BGN',
        domain: 'zooplus.bg',
        language: 'bg',
        locale: 'bg-BG',
        alternateLocales: [],
        productGroupId: 109610,
        realm: 'zooplus',
    },
    {
        id: 31,
        country: 'NO',
        currency: 'EUR',
        alternativeCurrency: 'NOK',
        domain: 'zooplus.no',
        language: 'nb',
        locale: 'nb-NO',
        alternateLocales: [],
        productGroupId: 120750,
        realm: 'zooplus',
    },
    {
        id: 32,
        country: 'GR',
        currency: 'EUR',
        alternativeCurrency: 'EUR',
        domain: 'zooplus.gr',
        language: 'el',
        locale: 'el-GR',
        alternateLocales: [],
        productGroupId: 199260,
        realm: 'zooplus',
    },
    {
        id: 33,
        country: 'AT',
        currency: 'EUR',
        alternativeCurrency: 'EUR',
        domain: 'zooplus.at',
        language: 'de',
        locale: 'de-AT',
        alternateLocales: [],
        productGroupId: 383929,
        realm: 'zooplus',
    },
    {
        id: 101,
        country: 'DE',
        currency: 'EUR',
        alternativeCurrency: 'EUR',
        domain: 'bitiba.de',
        language: 'de',
        locale: 'de-DE',
        alternateLocales: [],
        productGroupId: 116722,
        realm: 'bitiba',
    },
    {
        id: 102,
        country: 'GB',
        currency: 'EUR',
        alternativeCurrency: 'EUR',
        domain: 'bitiba.com',
        language: 'en',
        locale: 'en-GB',
        alternateLocales: [
            { language: 'hu', locale: 'hu-GB' },
            { language: 'ro', locale: 'ro-GB' },
            { language: 'sl', locale: 'sl-GB' },
            { language: 'sk', locale: 'sk-GB' },
            { language: 'pt', locale: 'pt-GB' },
        ],
        productGroupId: 689014,
        realm: 'bitiba',
    },
    {
        id: 103,
        country: 'GB',
        currency: 'EUR',
        alternativeCurrency: 'GBP',
        domain: 'bitiba.co.uk',
        language: 'en',
        locale: 'en-GB',
        alternateLocales: [],
        productGroupId: 113998,
        realm: 'bitiba',
    },
    {
        id: 104,
        country: 'FR',
        currency: 'EUR',
        alternativeCurrency: 'EUR',
        domain: 'bitiba.fr',
        language: 'fr',
        locale: 'fr-FR',
        alternateLocales: [],
        productGroupId: 99265,
        realm: 'bitiba',
    },
    {
        id: 107,
        country: 'NL',
        currency: 'EUR',
        alternativeCurrency: 'EUR',
        domain: 'bitiba.nl',
        language: 'nl',
        locale: 'nl-NL',
        alternateLocales: [],
        productGroupId: 133922,
        realm: 'bitiba',
    },
    {
        id: 108,
        country: 'PL',
        currency: 'EUR',
        alternativeCurrency: 'PLN',
        domain: 'bitiba.pl',
        language: 'pl',
        locale: 'pl-PL',
        alternateLocales: [],
        productGroupId: 122803,
        realm: 'bitiba',
    },
    {
        id: 111,
        country: 'IE',
        currency: 'EUR',
        alternativeCurrency: 'EUR',
        domain: 'bitiba.ie',
        language: 'en',
        locale: 'en-IE',
        alternateLocales: [],
        productGroupId: 689014,
        realm: 'bitiba',
    },
    {
        id: 112,
        country: 'IT',
        currency: 'EUR',
        alternativeCurrency: 'EUR',
        domain: 'bitiba.it',
        language: 'it',
        locale: 'it-IT',
        alternateLocales: [],
        productGroupId: 144325,
        realm: 'bitiba',
    },
    {
        id: 114,
        country: 'BE',
        currency: 'EUR',
        alternativeCurrency: 'EUR',
        domain: 'bitiba.be',
        language: 'fr',
        locale: 'fr-BE',
        alternateLocales: [],
        productGroupId: 155425,
        realm: 'bitiba',
    },
    {
        id: 115,
        country: 'ES',
        currency: 'EUR',
        alternativeCurrency: 'EUR',
        domain: 'bitiba.es',
        language: 'es',
        locale: 'es-ES',
        alternateLocales: [],
        productGroupId: 122801,
        realm: 'bitiba',
    },
    {
        id: 116,
        country: 'CZ',
        currency: 'EUR',
        alternativeCurrency: 'CZK',
        domain: 'bitiba.cz',
        language: 'cs',
        locale: 'cs-CZ',
        alternateLocales: [],
        productGroupId: 183922,
        realm: 'bitiba',
    },
    {
        id: 118,
        country: 'FI',
        currency: 'EUR',
        alternativeCurrency: 'EUR',
        domain: 'bitiba.fi',
        language: 'fi',
        locale: 'fi-FI',
        alternateLocales: [],
        productGroupId: 148494,
        realm: 'bitiba',
    },
    {
        id: 119,
        country: 'SK',
        currency: 'EUR',
        alternativeCurrency: 'EUR',
        domain: 'bitiba.sk',
        language: 'sk',
        locale: 'sk-SK',
        alternateLocales: [],
        productGroupId: 689014,
        realm: 'bitiba',
    },
    {
        id: 121,
        country: 'DK',
        currency: 'EUR',
        alternativeCurrency: 'DKK',
        domain: 'bitiba.dk',
        language: 'da',
        locale: 'da-DK',
        alternateLocales: [],
        productGroupId: 155429,
        realm: 'bitiba',
    },
    {
        id: 122,
        country: 'HU',
        currency: 'EUR',
        alternativeCurrency: 'HUF',
        domain: 'bitiba.hu',
        language: 'hu',
        locale: 'hu-HU',
        alternateLocales: [],
        productGroupId: 689014,
        realm: 'bitiba',
    },
    {
        id: 123,
        country: 'SI',
        currency: 'EUR',
        alternativeCurrency: 'EUR',
        domain: 'bitiba.si',
        language: 'sl',
        locale: 'sl-SI',
        alternateLocales: [],
        productGroupId: 689014,
        realm: 'bitiba',
    },
    {
        id: 124,
        country: 'RO',
        currency: 'EUR',
        alternativeCurrency: 'RON',
        domain: 'bitiba.ro',
        language: 'ro',
        locale: 'ro-RO',
        alternateLocales: [],
        productGroupId: 689014,
        realm: 'bitiba',
    },
    {
        id: 125,
        country: 'CH',
        currency: 'EUR',
        alternativeCurrency: 'CHF',
        domain: 'bitiba.ch',
        language: 'de',
        locale: 'de-CH',
        alternateLocales: [],
        productGroupId: 183921,
        realm: 'bitiba',
    },
    {
        id: 126,
        country: 'SE',
        currency: 'EUR',
        alternativeCurrency: 'SEK',
        domain: 'bitiba.se',
        language: 'sv',
        locale: 'sv-SE',
        alternateLocales: [],
        productGroupId: 155427,
        realm: 'bitiba',
    },
    {
        id: 128,
        country: 'PT',
        currency: 'EUR',
        alternativeCurrency: 'EUR',
        domain: 'bitiba.pt',
        language: 'pt',
        locale: 'pt-PT',
        alternateLocales: [],
        productGroupId: 689014,
        realm: 'bitiba',
    },
];
const filterDuplicates = (items) => {
    const filtered = [];
    items.forEach((item) => {
        if (!filtered.some((value) => item === value)) {
            filtered.push(item);
        }
    });
    return filtered;
};
const DOMAINS = SITES.map((site) => site.domain);
SITES.map((site) => site.realm);
SITES.map((site) => site.country);
filterDuplicates(SITES.flatMap((site) => [site.locale, ...site.alternateLocales.map((alt) => alt.locale)]));
filterDuplicates(SITES.flatMap((site) => [site.language, ...site.alternateLocales.map((alt) => alt.language)]));
filterDuplicates(SITES.flatMap((site) => [site.currency, site.alternativeCurrency]));

export { DOMAINS, SITES };
//# sourceMappingURL=lang.js.map
